
import { Col, List, Row, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { useGetMessageGroups } from "../../ServerSideStates";
import UserMessageItem from "./UserMessageItem";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import Search from "./Search";
import { handleSetUserMessageFilter } from "../../ClientSideStates";

const UserMessageList = () => {
  const { Text } = Typography;

  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { userFilter } = useSelector((state: RootState) => state.message);
  const messageGroups = useGetMessageGroups(userFilter);
  console.log("messageGroups", messageGroups)
  const dispatch = useDispatch()

  const handleChangePagination = (pageNum: number, pageSize: number) => {
    let newFilter = { ...userFilter, PageIndex: pageNum, PageSize: pageSize };
    dispatch(handleSetUserMessageFilter({ filter: newFilter }));
  };

  return (
    <>
      <Col xs={24} className=" !p-4 ">
        <Row gutter={[0, 20]} className="">
          <Col xs={24} className="!h-[70px] !flex items-center  ">
            <div className="!flex gap-4 items-center">
              <div className="relative w-[58px] h-[58px] flex items-center justify-center rounded-full border-2 border-green-500">
                <LazyLoadImage
                  wrapperWidth="50px"
                  wrapperHeight="50px"
                  //  userInfoes?.store?.length > 0
                  //     ? setBackEndUlr() + "/" + userInfoes?.store[0]?.photoUrl
                  //     :
                  src={
                    setBackEndUlr() + "/" + userInfoes?.photoUrl
                  }
                  alt=""
                  imageClassName="!rounded-full !object-contain"
                  classNames="!rounded-full !object-contain"
                />
              </div>
              <div>
                <Text className="!text-black !text-lg">{`${userInfoes?.name || ""
                  } ${userInfoes?.surname || ""}`}</Text>
              </div>
            </div>
          </Col>
          <Col xs={24} className="!hidden lg:!block bg-white rounded-md">
            <Search />
          </Col>
        </Row>
      </Col>

      <Col xs={24} className="!max-h-[1000px] !overflow-auto" >
        {/* <List

       className=""
          dataSource={messageGroups?.data?.data?.data || []}
          loading={messageGroups.isLoading}
          renderItem={(item) => <UserMessageItem item={item} />}
          pagination={{
           className:"!flex !justify-center md:!justify-end !p-4",
            onChange: handleChangePagination,
            total: messageGroups?.data?.data?.filteredCount||0,
            current: messageGroups?.data?.data?.PageIndex,
            pageSize: messageGroups?.data?.data?.PageSize !==-1?messageGroups?.data?.data?.PageSize:20,
            showLessItems: true,
            size: "small",
            showSizeChanger: true,
            locale: { items_per_page: "" },
            showTotal: (e) => `${e}`,
          }}
        /> */}
        <List
          className=""
          dataSource={
            [...(messageGroups?.data?.data?.data || [])]
              .sort(
                (a, b) =>
                  new Date(b.lastMessageDate).getTime() -
                  new Date(a.lastMessageDate).getTime()
              )
          }
          loading={messageGroups.isLoading}
          renderItem={(item) => <UserMessageItem item={item} />}
          pagination={{
            className: "!flex !justify-center md:!justify-end !p-4",
            onChange: handleChangePagination,
            total: messageGroups?.data?.data?.filteredCount || 0,
            current: messageGroups?.data?.data?.PageIndex,
            pageSize:
              messageGroups?.data?.data?.PageSize !== -1
                ? messageGroups?.data?.data?.PageSize
                : 20,
            showLessItems: true,
            size: "small",
            showSizeChanger: true,
            locale: { items_per_page: "" },
            showTotal: (e) => `${e}`,
          }}
        />

      </Col>
    </>
  );
};

export default UserMessageList;
